export default __webpack_public_path__ + "static/media/640_store03-es-web.8ad9ca01.png";